// extracted by mini-css-extract-plugin
export default {"ns_box_text_area":"NSBoxTextArea_ns_box_text_area__Uv-dj"};